import axios from 'axios';
import * as apiService from './apiService';
import { createAttributeModel } from '../models/attributeModel';
import { createAttributeValueModel } from '../models/attributeValueModel';

// const test1 = [{
//   "Evento": "1º Congresso Mundial, 5º Brasileiro e 5º Paulista de Urgências e Emergências Pediátricas",
//   "Status": "OK",
//   "Cod_Adesao": 126773,
//   "Categoria": "Outro Profissional - Não Prescritor",
//   "Nome": "DOUGLAS DECCO",
//   "EMail": "douglas.decco@inteegra.com.br"
// }];

// const test2 = [{
//   "Evento": "1º Congresso Mundial, 5º Brasileiro e 5º Paulista de Urgências e Emergências Pediátricas",
//   "Status": "SEM REGISTRO"
// }]

// EVENTID = 191048

// Nome - ID 1030804
// Email - ID 1030805
// Evento - ID 1046343
// Status - ID 1046344
// Cod_Adesao - ID 1046448
// Categoria - ID 1046449

const ekpService = {
  async login(email = '') {
    try {
      const _ret = await axios({
        url: apiService.getUrl().ekpLogin,
        method: "GET",
        params: {
          email: email,
        },
      });
      // const _ret = {
      //   data: test1
      // };

      if (_ret.data[0].Status === 'PENDENTE' || _ret.data[0].Status === 'SEM REGISTRO') {
        return _ret.data[0];
      }

      let _exists = await checkIfGuestExists(email);
      if (!_exists.exists) {
        await saveGuest(_ret.data[0]);
      }

      return _ret.data[0];
    } catch (error) {
      console.log('Error login', error);
      throw error;
    }

    async function checkIfGuestExists(email) {
      try {
        const _ret = await axios({
          url: `https://api-externa.inteegra.com.br/public/api/admin/guests/existsbyattribute/v3`,
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          params: {
            EventId: 191048,
            AttributeId: 1030805,
            Value: btoa(email),
          },
        });

        if (!_ret?.data?.Exists) {
          return {
            exists: _ret?.data?.Exists || false,
          };
        }

        return {
          exists: true,
        };
      } catch (error) {
        console.log('Error checkIfGuestExists', error);
        throw error;
      }
    }

    async function saveGuest(loginData) {
      try {
        const _attributesList = getAttributesList(loginData);

        const _ret = await axios({
          url: `https://api-externa.inteegra.com.br/public/api/admin/guests`,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          data: {
            ContractId: 2042,
            EventId: 191048,
            Email: email,
            GroupId: null,
            ConfirmationStatus: 'CN',
            Code1: '',
            Code2: '',
            Code3: '',
            Attributes: _attributesList,
          },
        });

        if (_ret.status !== 200) {
          throw new Error('Erro ao salvar participante');
        }

        return {
          id: _ret.data.Data.Id,
          name: _ret.data.Data.Name,
          email: _ret.data.Data.Email,
        };
      } catch (error) {
        console.log('Error saveGuest', error);
        throw error;
      }

      function getAttributesList(loginData) {
        return [
          {
            AttributeId: 1030804,
            Value: loginData.Nome,
          },
          {
            AttributeId: 1030805,
            Value: loginData.EMail,
          },
          {
            AttributeId: 1046343,
            Value: loginData.Evento,
          },
          {
            AttributeId: 1046344,
            Value: loginData.Status,
          },
          {
            AttributeId: 1046448,
            Value: loginData.Cod_Adesao.toString(),
          },
          {
            AttributeId: 1046449,
            Value: loginData.Categoria,
          },
        ];
      }
    }
  },
}

export default ekpService;
